
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import {
  About,
  Decentralization,
  Projects,
  Services,
} from "../components/sections";
import { useMatchMedia } from "../hooks";

export default function HomePage() {
  const isMobileResolution = useMatchMedia("(max-width:970px)", undefined);
  return (
    <>
      <Decentralization isMobileResolution={isMobileResolution} />
      <Services />
      <About isMobileResolution={isMobileResolution} />
      <Projects />
    </>
  );
}


    export async function getStaticProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/index',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  